import { Injectable } from '@angular/core';
import { APP_ROUTES } from '@app/constants';
import { API_URLS } from '@app/constants/apiUrls';
import { ApiHelper } from '@app/helpers';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(private apiHelper: ApiHelper) { }

  list(surveyId?: string | null) {
    let query: any = {}
    if(surveyId) query.survey = surveyId;

    return this.apiHelper.get(API_URLS.FORM, query)
  }

  add(payload: any) {
    return this.apiHelper.post(API_URLS.FORM, payload)
  }

  update(id: string, payload: any) {
    return this.apiHelper.put(`${API_URLS.FORM}/${id}`, payload)
  }

  info(id: string) {
    return this.apiHelper.get(`${API_URLS.FORM}/${id}`)
  }

  publish(id: string) {
    return this.apiHelper.put(`${API_URLS.FORM}/${id}/publish`);
  }

  delete(id: string) {
    return this.apiHelper.delete(`${API_URLS.FORM}/${id}`);
  }
}
